import PropTypes from 'prop-types';

/**
 *
 * @param dateA
 * @param dateB
 * @returns true if the dates are the same, false otherwise
 */
export function isSameDate(dateA, dateB) {
  return (
    dateA === dateB ||
    (dateA && dateB && dateA.isSame && dateB.isSame && dateA.isSame(dateB, 'day'))
  );
}

/**
 * Prop type of date type parameters
 */
export const DatePropType = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.number]);

/**
 * the shared prop types between all components
 *
 */
export const dateInputSharedProps = {
  /**
   * Language locale
   */
  locale: PropTypes.string,
  /**
   * Flag whether the date picker is for a date range of a single value
   */
  range: PropTypes.bool,
  /**
   * Allow selection of dates after minDate
   */
  minDate: DatePropType,
  /**
   * Allow selection of dates before maxDate
   */
  maxDate: DatePropType,
  /**
   * the selected date value (for no range)
   */
  selectedValue: DatePropType,
  /**
   * A selected start date for a calendar with range data (should be used with range=true)
   */
  startDate: DatePropType,
  /**
   * A selected end date for a calendar with range data (should be used with range=true)
   */
  endDate: DatePropType,
  /**
   * Disable selection of passed dates
   */
  disablePastDates: PropTypes.bool,
  /**
   * Disable selection of future dates
   */
  disableFutureDates: PropTypes.bool
};
